import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Container, TextField, Button, Typography, Box, Paper, ToggleButton, ToggleButtonGroup } from "@mui/material";

const API = process.env.REACT_APP_API_URL;

const SignIn = () => {
  const [mode, setMode] = useState("user"); // "user" (mobile) | "admin" (credentials)
  const [mobile, setMobile] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleUserSignIn = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await axios.post(`${API}/api/auth/signin`, { mobile });
      if (res.data.role === "admin") {
        navigate("/admin", { state: { user: res.data } });
      } else {
        navigate("/user", { state: { user: res.data } });
      }
    } catch (err) {
      setError(err.response?.data?.error || "Sign in failed");
    }
  };

  const handleAdminSignIn = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await axios.post(`${API}/api/auth/admin-login`, { username, password });
      localStorage.setItem("admin_token", res.data.token);
      navigate("/admin", { state: { user: { role: "admin", name: res.data.username } } });
    } catch (err) {
      setError(err.response?.data?.error || "Admin login failed");
    }
  };

  return (
    <Container maxWidth="xs">
      <Paper elevation={3} sx={{ mt: 10, p: 4, borderRadius: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Typography component="h1" variant="h4" fontWeight={700} color="primary" gutterBottom>DC-JOBS</Typography>
          <ToggleButtonGroup
            value={mode}
            exclusive
            size="small"
            onChange={(_, v) => { if (v) { setMode(v); setError(""); } }}
            sx={{ mb: 2 }}
          >
            <ToggleButton value="user">User</ToggleButton>
            <ToggleButton value="admin">Admin</ToggleButton>
          </ToggleButtonGroup>

          {mode === "user" ? (
            <Box component="form" onSubmit={handleUserSignIn} sx={{ width: "100%" }}>
              <TextField
                margin="normal" required fullWidth label="Mobile Number"
                value={mobile} onChange={(e) => setMobile(e.target.value)} autoFocus
              />
              {error && <Typography color="error" sx={{ mt: 1 }}>{error}</Typography>}
              <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 1 }}>Sign In</Button>
            </Box>
          ) : (
            <Box component="form" onSubmit={handleAdminSignIn} sx={{ width: "100%" }}>
              <TextField
                margin="normal" required fullWidth label="Username"
                value={username} onChange={(e) => setUsername(e.target.value)} autoFocus
              />
              <TextField
                margin="normal" required fullWidth label="Password" type="password"
                value={password} onChange={(e) => setPassword(e.target.value)}
              />
              {error && <Typography color="error" sx={{ mt: 1 }}>{error}</Typography>}
              <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 1 }}>Admin Login</Button>
            </Box>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default SignIn;
